import React, { useMemo } from "react";
import ReactEcharts from "echarts-for-react";
import _ from "lodash";
import ChartStyle from "styles/ChartStyle";
import * as echarts from "echarts";
import { useSelector } from "react-redux";
import assetConfig from "utils/pictree/AssetConfig";
import * as V from 'styles/variables';

const ChartPictreeReportTrend = () => {
  const trendData = useSelector(state => state.pictree.reportTrend.data);
  const { reportTagSortTepco } = assetConfig;

  const option = useMemo(() => {
    if (!Array.isArray(trendData) || trendData.length === 0) return {};

    const tagSet = new Set();
    const xAxisData = trendData.map(d => d.date);

    // series用データ作成
    const seriesMap = {};
    trendData.forEach(d => {
      Object.entries(d).forEach(([tag, count]) => {
        if (tag === "date") return;
        tagSet.add(tag);
        if (!seriesMap[tag]) seriesMap[tag] = [];
      });
    });

    // 0埋め
    trendData.forEach(d => {
      tagSet.forEach(tag => {
        seriesMap[tag].push(d[tag] || 0);
      });
    });

    const sortedTags = [...tagSet].sort((a, b) => {
      const iA = reportTagSortTepco.indexOf(a);
      const iB = reportTagSortTepco.indexOf(b);
      return (iA === -1 ? 999 : iA) - (iB === -1 ? 999 : iB);
    });

    const series = sortedTags.map(tag => ({
      name: tag,
      type: "bar",
      stack: "total",
      emphasis: {
        focus: "series",
      },
      data: seriesMap[tag],
      barMaxWidth: 40,
    }));

    return {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      legend: {
        data: sortedTags,
      },
      grid: {
        left: 64,
        top: 48,
        right: 48,
        bottom: 32,
      },
      xAxis: {
        type: "category",
        data: xAxisData,
      },
      yAxis: {
        type: "value",
        name: "報告件数",
      },
      color: V.genericColorPallette,
      series,
    };
  }, [trendData]);

  return (
    <ReactEcharts
      option={option}
      theme="BarChartTheme"
      style={{ height: 400, width: "100%" }}
    />
  );
};

export default ChartPictreeReportTrend;
